import React, { Component } from 'react'
import moment from 'moment'
import { Line } from 'react-chartjs-2'

const config = {
  type: 'line',
  options: {
    scales: {
      xAxes: [{
        type: 'time',
        time: {
          displayFormats: {
            millisecond: 'MMM DD',
            second: 'MMM DD',
            minute: 'MMM DD',
            hour: 'MMM DD',
            day: 'MMM DD',
            week: 'MMM DD',
            month: 'MMM DD',
            quarter: 'MMM DD',
            year: 'MMM DD'
          }
        }
      }]
    }
  }
}

class EventsChart extends Component {
  componentDidMount () {
    const e = this.props.events
    const labels = []
    const severity = []
    const autosensor = []
    const speed = []
    const max = []
    e.forEach(element => {
      labels.push(moment.unix(element.detection_date))
      severity.push(element.severity)
      autosensor.push(element.autosensor)
      speed.push(element.speed)
      max.push(element.max)
    })
    const data = {
      labels,
      datasets: [{
        label: 'Grado',
        data: severity,
        backgroundColor: 'rgba(33, 150, 243, 0.2)',
        borderColor: 'rgba(33, 150, 243, 1)',
        // lineTension: 0.1,
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: '#1976D2',
        pointBackgroundColor: '#1976D2',
        pointBorderWidth: 1,
        pointRadius: 3
      }, {
        label: 'Autosensor',
        data: autosensor,
        backgroundColor: ['rgba(0, 188, 212, 0.2)'],
        borderColor: ['rgba(0, 188, 212, 1)'],
        // lineTension: 0.1,
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: '#00BCD4',
        pointBackgroundColor: '#00BCD4',
        pointBorderWidth: 1,
        pointRadius: 3
      }, {
        label: 'Velocità',
        data: speed,
        backgroundColor: ['rgba(63, 81, 181, 0.2)'],
        borderColor: ['rgba(63, 81, 181, 1)'],
        // lineTension: 0.1,
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: '#3F51B5',
        pointBackgroundColor: '#3F51B5',
        pointBorderWidth: 1,
        pointRadius: 3
      }, {
        label: 'Valore massimo rilevato',
        data: max,
        backgroundColor: ['rgba(156, 39, 176, 0.2)'],
        borderColor: ['rgba(156, 39, 176, 1)'],
        // lineTension: 0.1,
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderColor: '#7B1FA2',
        pointBackgroundColor: '#7B1FA2',
        pointBorderWidth: 1,
        pointRadius: 3
      }]
    }
    this.setState({ data })
  }

  render () {
    return (
      <div>
        {
          this.state !== null && (
            <Line
              data={this.state.data}
              width={100}
              height={50}
              options={config.options}
            />
          )
        }
      </div>
    )
  }
}

export default EventsChart
